<div class="workspace bg-radial">
  <top-bar [titleTranslationCode]="'LESSONS.TITLE'"
           [redirectLink]="'../../'"
           [redirectTranslationCodes]="'NAVIGATION.LESSONS'"
           class="accent">
    <footer>
      <div class="row d-none d-md-flex">
        <div class="col-10">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" aria-current="page">
                <a routerLink="../../">
                  {{ "LESSONS.TITLE" | translate }}
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {{ 'COL.LESSONS.DETAILS.TITLE' | translate}}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </footer>
  </top-bar>
  <div class="container mt-md-3">
    <div class="row position-relative pb-3">
      <spinner class="w-100 spinner"></spinner>
    </div>
    <div *ngIf="isProva(), else noProva">
      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item">
          <button
            class="nav-link active"
            id="about-lesson-tab"
            data-bs-toggle="pill"
            data-bs-target="#about-lesson"
            type="button" role="tab"
            aria-controls="about-lesson"
            aria-selected="true">
            {{ "COL.LESSONS.DETAILS.TABS.ABOUT_YOUR_LESSON" | translate }}
          </button>
        </li>
        <li class="nav-item" >
          <button
            class="nav-link"
            id="prepare-to-connect-tab"
            data-bs-toggle="pill"
            data-bs-target="#prepare-to-connect"
            type="button" role="tab"
            aria-controls="prepare-to-connect"
            aria-selected="false">
            {{ "COL.LESSONS.DETAILS.TABS.PREPARE_TO_CONNECT" | translate }}
          </button>
        </li>
      </ul>
      <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show active" id="about-lesson">
          <app-student-lesson-details [studentId]="studentId" [lesson]="lesson"></app-student-lesson-details>
        </div>
        <div class="tab-pane fade" id="prepare-to-connect">
          <app-prepare-to-connect-tab [kids]="isKidsEnglish()"></app-prepare-to-connect-tab>
        </div>
      </div>
    </div>
    <ng-template #noProva>
      <div>
        <app-student-lesson-details [studentId]="studentId" [lesson]="lesson"></app-student-lesson-details>
      </div>
    </ng-template>
  </div>
</div>
